<template>
  <div class="dify-chatbot-container">
    <!-- 页面内容 -->
    <!-- <div class="page-content">
      <header class="page-header">
        <h1>Vue Dify聊天机器人示例</h1>
        <p>这个页面展示了如何在Vue应用中使用Dify聊天机器人</p>
      </header>
      
      <div class="content-wrapper">
        <main class="main-content">
          <h2>主要内容区域</h2>
          <p>这是您的应用主要内容区域。Dify聊天机器人将显示在页面右下角。</p>
          <p>您可以与机器人进行对话，它会在您需要帮助时提供支持。</p>
          
          <div class="feature-section">
            <div class="feature-card">
              <h3>智能对话</h3>
              <p>基于AI的智能对话系统，能够理解您的需求并提供帮助</p>
            </div>
            <div class="feature-card">
              <h3>易于集成</h3>
              <p>简单的Vue组件集成方式，几行代码即可添加聊天功能</p>
            </div>
            <div class="feature-card">
              <h3>完全可定制</h3>
              <p>可以根据您的品牌风格自定义聊天机器人的外观</p>
            </div>
          </div>
        </main>
        
        <aside class="sidebar">
          <h3>使用说明</h3>
          <ul>
            <li>点击右下角的红色按钮打开聊天窗口</li>
            <li>与机器人进行对话获取帮助</li>
            <li>聊天窗口可以拖拽移动位置</li>
            <li>点击关闭按钮或再次点击红色按钮关闭聊天窗口</li>
          </ul>
          
          <h3>配置选项</h3>
          <div class="config-options">
            <div class="option-item">
              <label>用户ID:</label>
              <input 
                type="text" 
                v-model="userId" 
                placeholder="可选，设置用户ID"
              >
            </div>
            <div class="option-item">
              <label>会话ID:</label>
              <input 
                type="text" 
                v-model="conversationId" 
                placeholder="可选，设置会话ID"
              >
            </div>
            <button @click="updateConfig" class="update-btn">更新配置</button>
          </div>
        </aside>
      </div>
    </div> -->
    
    <!-- Dify聊天机器人将通过脚本动态加载 -->
  </div>
</template>

<script>
export default {
  name: 'DifyChatbot',
  data() {
    return {
      userId: !this.$store.state.user.data ? '未登录或未注册用户' : this.$store.state.user.data.userName,
      conversationId: '',
      difyScript: null
    }
  },
  mounted() {
    this.loadDifyChatbot();
  },
  beforeUnmount() {
    this.cleanupDifyChatbot();
  },
  methods: {
    loadDifyChatbot() {
      // 设置Dify配置
      window.difyChatbotConfig = {
        token: 'wvJnA5d3FU636jni',
        baseUrl: 'https://dify.yifucj.com',
        systemVariables: {
          user_id: this.userId || undefined,
          conversation_id: this.conversationId || undefined,
        },
      };
      
      // 创建并加载Dify脚本
      this.difyScript = document.createElement('script');
      this.difyScript.src = 'https://dify.yifucj.com/embed.min.js';
      this.difyScript.id = 'wvJnA5d3FU636jni';
      this.difyScript.defer = true;
      document.head.appendChild(this.difyScript);
    },
    
    cleanupDifyChatbot() {
      // 清理脚本和样式
      if (this.difyScript) {
        document.head.removeChild(this.difyScript);
        this.difyScript = null;
      }
      
      // 移除Dify创建的DOM元素
      const difyElements = document.querySelectorAll('[id^="dify-chatbot"]');
      difyElements.forEach(el => {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    },
    
    updateConfig() {
      // 清理现有聊天机器人
      this.cleanupDifyChatbot();
      
      // 重新加载聊天机器人
      setTimeout(() => {
        this.loadDifyChatbot();
      }, 100);
    }
  }
}
</script>

<style>
     #dify-chatbot-bubble-button {
       background-color: #1C64F2 !important;
     }
     #dify-chatbot-bubble-window {
         position: fixed !important;
       width: 35rem !important;
       height: 38rem !important;
     }
/* .dify-chatbot-container {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  color: #333;
  line-height: 1.6;
}

.page-header {
  text-align: center;
  padding: 30px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  margin-bottom: 30px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.page-header h1 {
  margin: 0 0 10px 0;
  color: #2c3e50;
  font-size: 2.5rem;
}

.page-header p {
  margin: 0;
  color: #546e7a;
  font-size: 1.1rem;
}

.content-wrapper {
  display: flex;
  gap: 30px;
}

.main-content {
  flex: 1;
  padding: 25px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.main-content h2 {
  color: #2c3e50;
  margin-top: 0;
  border-bottom: 2px solid #e43a3d;
  padding-bottom: 10px;
}

.feature-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.feature-card {
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #e43a3d;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.feature-card h3 {
  margin-top: 0;
  color: #2c3e50;
}

.sidebar {
  flex: 0 0 300px;
  padding: 25px;
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.sidebar h3 {
  color: #2c3e50;
  margin-top: 0;
  border-bottom: 2px solid #e43a3d;
  padding-bottom: 8px;
}

.sidebar ul {
  padding-left: 20px;
  margin-bottom: 25px;
}

.sidebar li {
  margin-bottom: 10px;
}

.config-options {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.option-item {
  display: flex;
  flex-direction: column;
}

.option-item label {
  margin-bottom: 5px;
  font-weight: 500;
  color: #2c3e50;
}

.option-item input {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.update-btn {
  padding: 12px 20px;
  background-color: #e43a3d;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s;
}

.update-btn:hover {
  background-color: #c12d30;
} */

/* Dify聊天机器人样式 */
/* :deep(#dify-chatbot-bubble-button) {
  background-color: #e43a3d !important;
}

:deep(#dify-chatbot-bubble-window) {
  width: 45rem !important;
  height: 40rem !important;
} */

/* 响应式设计 */
/* @media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
  }
  
  .sidebar {
    flex: 1;
  }
  
  .feature-section {
    grid-template-columns: 1fr;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
} */
</style>